import WebApi from "@/views/loyalty/shared/modules/web_api"

export class BotEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_NOTIF_URL}api/bot/`
        console.log('url', this.url)
        this.webApi = new WebApi()
    }

    async check (userId) {
        const action = await this.webApi.get(`${this.url}check/${userId}`)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
        }
    }
}
